import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { ledgerAccountColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiLedgerAccount } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { LedgerAccountsRepository } from '@Repositories/Stammdaten';

export function FrameListLedgerAccount() {
    const hasPermission = useHasPermission();

    const module = useListApi(LedgerAccountsRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiLedgerAccount>
            layoutSettingsContext={EnumFrontendLayoutSetting.LedgerAccountsTableLayout}
            name="LedgerAccountList"
            columns={ledgerAccountColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenLedgerAccountCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
